import React from 'react'
import { Combobox, Input, MultiSelect, Select } from '@/components/ui'
import {
  CURRENCY_OPTIONS,
  DATE_FORMAT_OPTIONS,
  filterTimezoneOptions,
  WEEKDAY_OPTIONS,
} from '@/features/organization/constants/settingsOptions'
import { FieldGrid, FieldGroup, SettingsPane } from '../organization-ui'
import type { OrganizationSettingsFormProps } from '../settings/organizationSettingsForm.types'

export const GeneralPane: React.FC<OrganizationSettingsFormProps> = ({
  register,
  errors,
  setValue,
  watch,
  disabled = false,
}) => (
  <SettingsPane
    title="General"
    description="Regional defaults every module inherits — currency, time, and the working week."
  >
    <FieldGroup label="Money">
      <FieldGrid columns={2}>
        <Select
          label="Default currency"
          options={CURRENCY_OPTIONS}
          value={watch('defaultCurrency') ?? ''}
          onChange={(v) => setValue('defaultCurrency', v, { shouldDirty: true })}
          placeholder="Select currency"
          disabled={disabled}
        />
        <MultiSelect
          label="Supported currencies"
          options={CURRENCY_OPTIONS}
          value={watch('supportedCurrencies') ?? []}
          onChange={(v) => setValue('supportedCurrencies', v, { shouldDirty: true })}
          placeholder="Select currencies"
          disabled={disabled}
        />
      </FieldGrid>
    </FieldGroup>

    <FieldGroup label="Time and locale">
      <FieldGrid>
        <Combobox
          label="Timezone"
          loadOptions={(query) => Promise.resolve(filterTimezoneOptions(query))}
          value={watch('timezone') ?? ''}
          onChange={(v) => setValue('timezone', v, { shouldDirty: true })}
          placeholder="Search timezone"
          disabled={disabled}
        />
        <Select
          label="Date format"
          options={DATE_FORMAT_OPTIONS}
          value={watch('dateFormat') ?? ''}
          onChange={(v) => setValue('dateFormat', v, { shouldDirty: true })}
          placeholder="Select format"
          disabled={disabled}
        />
        <MultiSelect
          label="Work week days"
          options={WEEKDAY_OPTIONS}
          value={watch('workWeek') ?? []}
          onChange={(v) => setValue('workWeek', v, { shouldDirty: true })}
          placeholder="Select days"
          disabled={disabled}
        />
      </FieldGrid>
    </FieldGroup>

    <FieldGroup label="Identifiers">
      <FieldGrid>
        <Input
          label="Company code prefix"
          {...register('companyCodePrefix')}
          error={errors.companyCodePrefix?.message}
          hint="2–10 letters or numbers, prepended to generated company codes."
          placeholder="LOS"
          disabled={disabled}
          className="uppercase tracking-[0.08em]"
          autoComplete="off"
        />
      </FieldGrid>
    </FieldGroup>
  </SettingsPane>
)

GeneralPane.displayName = 'GeneralPane'
